"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarkBooleanValue = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const icons_1 = require("../../atoms/icons");
const renderContent = (value, size = "1x") => {
    if (value === undefined || value === null || value === "null") {
        return ((0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", color: "light-grey", size: size, children: "-" }, void 0));
    }
    if (!value || value === "false") {
        return ((0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", color: "pink", icon: ["fal", "times"], size: size }, void 0));
    }
    return ((0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", color: "green", icon: ["fal", "check"], size: size }, void 0));
};
const MarkBooleanValue = (props) => ((0, jsx_runtime_1.jsx)(Wrapper, { children: renderContent(props.value, props.size) }, void 0));
exports.MarkBooleanValue = MarkBooleanValue;
const Wrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
`;
//# sourceMappingURL=index.js.map